import { type FormikErrors } from 'formik';
import * as Yup from 'yup';
import type { MultiInputTag } from '@rsos/components/capstone/base/form/inputs/MultiEntryInput/MultiEntryInput';
import {
  INVALID_NUMBER,
  MSG_REQUEST_ERROR,
  INVALID_NUMBER_ERROR,
  NUMBER_ALREADY_CALLED_911,
  EXISTING_CONVERSATION_ERROR,
} from './constants';

export type OutboundSMSValues = {
  phoneNumber: string;
  phoneNumberTags: MultiInputTag[];
  initialOutboundMessage: string;
};

export const initialValues: OutboundSMSValues = {
  phoneNumber: '',
  phoneNumberTags: [],
  initialOutboundMessage: '',
};

export type ConversationResponse = {
  error?: { status?: number };
  data?: { conversation_id?: string };
};

export type ConversationMutationTuple = [
  (opt: {
    callerID: string;
    message?: string;
    orgName?: string;
    languageCode?: string;
    doNotTranslate?: string[];
  }) => Promise<ConversationResponse>,
  { isLoading: boolean },
];

export const initialErrorState = {
  [MSG_REQUEST_ERROR]: false,
  [INVALID_NUMBER_ERROR]: false,
  [NUMBER_ALREADY_CALLED_911]: false,
  [EXISTING_CONVERSATION_ERROR]: false,
};

export const isBtnDisabled = (
  errors: FormikErrors<OutboundSMSValues>,
  values: OutboundSMSValues,
) =>
  !!errors.phoneNumberTags ||
  !!errors.initialOutboundMessage ||
  !values.phoneNumberTags.length;

export const CALLER_ID_BOUND_URL_PATTERNS = ['assist/locationrequest?'];

export const containsCallerIdBoundUrl = (
  message: string,
  patterns: string[] = CALLER_ID_BOUND_URL_PATTERNS,
) => patterns.some(pattern => message.includes(pattern));

export const validationSchema = Yup.object().shape({
  phoneNumberTags: Yup.array().test(
    'isValidNumber',
    'Invalid Phone number',
    function (entries) {
      if (entries?.length) {
        const { path, createError } = this;
        const result = !entries[0].isValid
          ? createError({ path, message: INVALID_NUMBER })
          : true;
        return result;
      }
      return true;
    },
  ),
  initialOutboundMessage: Yup.string().max(
    600,
    ({ value, max }) => `Character limit exceeded: ${value.length}/${max}`,
  ),
});
